import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { ChangeRegionComponent } from '@root/search/components/change-region/change-region.component';
import { SidePanelTab } from '@store/search-board/search-board.model';
import { ModalType } from '@shared/models/modal.model';
import { MixpanelService } from '@shared/services/mixpanel.service';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectSelectedSearch } from '@store/search-board/search-board.selector';
import { AppState } from '@root/app-state.module';
import { map, take } from 'rxjs/operators';
import { GetMySearchData } from '@store/user/user.actions';

@Component({
  selector: 'rlst-search-panel',
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchPanelComponent implements OnInit {
  @Input() sidePanelOpened: boolean;
  @Input() sidePanelTabOpened: SidePanelTab;
  @Input() totalGridRecords: number;
  @Input() searchResultsCount: number;
  @Input() currentGridPage: number;
  @Input() currentCounty: string;
  @Input() currentCountyTooltip: string;
  @Input() isLoginInProgress: boolean = true;
  @Output() toggledSidePanel: EventEmitter<void> = new EventEmitter();
  @Output() sidePanelTab: EventEmitter<SidePanelTab> = new EventEmitter<SidePanelTab>();
  @Output() changeGridPage: EventEmitter<number> = new EventEmitter<number>();
  @Output() clearSearchResults: EventEmitter<void> = new EventEmitter<void>();
  public sidePanelTabState: typeof SidePanelTab = SidePanelTab;
  public isSelectedSearch$: Observable<boolean>;

  constructor(
    private readonly store$: Store<AppState>,
    private readonly dialog: MatDialog,
    private readonly mixpanelService: MixpanelService
  ) { }

  public ngOnInit() {
    this.isSelectedSearch$ = this.store$.pipe(select(selectSelectedSearch), map((value) => {
      return !!value;
    }));
  }

  changeRegionClick() {
    this.mixpanelService.track('Search - County Click');
    this.dialog.open(ChangeRegionComponent, {
       data: { showFilter: false },
       panelClass: ModalType.LARGE
    } as MatDialogConfig);
  }

  toggleSidePanel() {
    this.toggledSidePanel.emit();
  }

  public openTab(tab: SidePanelTab): void {
    if (tab === SidePanelTab.mySearch) {
      this.isSelectedSearch$.pipe(take(1)).subscribe((value) => {
        if (!value) {
          this.store$.dispatch(new GetMySearchData());
        }
      })
    }
    this.sidePanelTab.emit(tab);
  }

  clearSearchResultsAction() {
    this.clearSearchResults.emit();
    this.mixpanelService.track('Search - Clear Search', {
      searchType: this.sidePanelTabOpened
    });
  }
}
